import { fetchJson } from '@/lib/api/api.helpers';
import { z } from 'zod';

const saasParamsSchema = z.object({
  maintenanceModeFront: z.boolean(),
  maintenanceModeAdmin: z.boolean(),
  openRegister: z.boolean(),
  openCompetitionRegistration: z.boolean(),
  referralEnabled: z.boolean(),
  playerPlusEnabled: z.boolean(),
  maintenanceMessage: z.string().nullable(),
  updatedAt: z.string(),
});

export type SaasParams = z.infer<typeof saasParamsSchema>;

export function getSaasParams(): Promise<SaasParams> {
  return fetchJson(`${import.meta.env.VITE_URL_API}/v1/saas-params`, { method: 'GET' }, saasParamsSchema);
}
